import * as React from 'react'

import { InfiniteSearchResults } from '../../../infinite-search-results'
import { AnyHitBlockView } from '../../hits/any-hit'

export const BlockTabView = () => (
  <InfiniteSearchResults
    wrapperClass="infinite-hits block-view"
    hitComponent={AnyHitBlockView} />
)
